import { CoherenceTreeItem, CoherenceTreeView } from '@coherence-design-system/controls';
import { makeStyles, MessageBar, MessageBarBody, SearchBox } from '@fluentui/react-components';
import { NeutralColors } from '@fluentui/react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import React from 'react';
import { bodyContentContainer, searchBoxStyles } from '../../app/common/styles/CommonStyleObjects';

interface ITreeView {
  treeItems: CoherenceTreeItem[];
  children: JSX.Element;
  navSectionHeader?: JSX.Element;
  commandBarSection?: JSX.Element;
  showSearchBox?: boolean;
  handleOnChangeSearch?: (
    event: React.ChangeEvent<HTMLInputElement>,
    data: { value: string },
  ) => void;
}
const useStyles = makeStyles({
  mainSection: {
    width: '320px',
    minWidth: '320px',
    background: NeutralColors.gray10,
  },
  detailsSection: {
    background: NeutralColors.white,
  },
  childrenWrapper: {
    width: '100%',
    padding: '30px',
  },
  mobileView: {
    [`@media (max-width: 1023px)`]: {
      flexFlow: 'column',
    },
  },
  treeContainer: {
    '& [class*="itemTitle"]': {
      paddingLeft: '32px',
    },
  },
});

const TreeView = ({
  treeItems,
  children,
  navSectionHeader,
  commandBarSection,
  showSearchBox,
  handleOnChangeSearch,
}: ITreeView): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={`${bodyContentContainer}  ms-depth-4`}>
      <Stack horizontal className={classes.mobileView}>
        <Stack className={classes.mainSection}>
          {navSectionHeader}
          {showSearchBox && (
            <SearchBox
              aria-label="search actions"
              placeholder="Search actions"
              onChange={handleOnChangeSearch}
              style={searchBoxStyles}
            />
          )}
          {treeItems.length === 0 && (
            <MessageBar intent="info" layout="multiline">
              <MessageBarBody>
                <span>No results found. Please try again.</span>
              </MessageBarBody>
            </MessageBar>
          )}
          <div className={classes.treeContainer}>
            <CoherenceTreeView data={treeItems} />
          </div>
        </Stack>
        <Stack grow className={classes.detailsSection}>
          {commandBarSection}
          <Stack className={classes.childrenWrapper}>{children}</Stack>
        </Stack>
      </Stack>
    </div>
  );
};
export default TreeView;
